(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("events"), require("ws"));
	else if(typeof define === 'function' && define.amd)
		define("OptaveJavaScriptSDK", ["events", "ws"], factory);
	else if(typeof exports === 'object')
		exports["OptaveJavaScriptSDK"] = factory(require("events"), require("ws"));
	else
		root["OptaveJavaScriptSDK"] = factory(root["events"], root["ws"]);
})((typeof globalThis !== 'undefined' ? globalThis : this), (__WEBPACK_EXTERNAL_MODULE__761__, __WEBPACK_EXTERNAL_MODULE__2__) => {
return 